"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectType = exports.ConfigType = exports.ButtonType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _paulCorePackage = require("paul-core-package");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const {
  filterTypes
} = _paulCorePackage.constants;
const ButtonType = exports.ButtonType = _propTypes.default.shape({
  text: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  value: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired).isRequired,
  type: _propTypes.default.oneOf([filterTypes.button]).isRequired,
  grouped: _propTypes.default.bool,
  id: _propTypes.default.string
});
const SelectType = exports.SelectType = _propTypes.default.shape({
  placeholder: _propTypes.default.string,
  value: _propTypes.default.string.isRequired,
  type: _propTypes.default.oneOf([filterTypes.select]).isRequired,
  id: _propTypes.default.string
});
/** temporarily unavailable */
// export const SearchType = PropTypes.shape({
//   placeholder: PropTypes.string,
//   type: PropTypes.oneOf([filterTypes.search]).isRequired,
//   option: PropTypes.func,
//   id: PropTypes.string,
// });

const ConfigType = exports.ConfigType = _propTypes.default.arrayOf(_propTypes.default.oneOfType([ButtonType, SelectType]));